import { Department } from '@apps/its2/domain/models/department';
import { StatusesMetadata } from '@common/models';

export const RootDepartmentsFeatureKey = 'departments';

export interface IRootDepartmentsState extends StatusesMetadata
{
    departments: Department[];
}

export const RootDepartmentsInitialState: IRootDepartmentsState = {
    departments: [],
    isLoading: false,
    isLoaded: false,
    isEmpty: false,
    isOups: false,
    expirationDate: null
};
